import React from 'react';
import { Asset } from './asset';
import { cs } from '../utils';
import { Text } from './text';
import { useNotionContext } from '..';
import { parsePageId } from '@simpledotink/notion-utils';
import ErrorBoundary from './ErrorBoundary';
export var AssetWrapper = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var blockId = _a.blockId, block = _a.block;
    var value = block;
    var _l = useNotionContext(), components = _l.components, mapPageUrl = _l.mapPageUrl, rootDomain = _l.rootDomain;
    // remove unused image
    var source = (_c = (_b = value === null || value === void 0 ? void 0 : value.properties) === null || _b === void 0 ? void 0 : _b.source) === null || _c === void 0 ? void 0 : _c[0];
    if (block.type === 'image' &&
        !(((_d = value.format) === null || _d === void 0 ? void 0 : _d.display_source) ||
            (source &&
                source.indexOf('http') === 0 &&
                source.indexOf('googleusercontent')) != -1))
        return null;
    // remove inline images
    if (source === null || source === void 0 ? void 0 : source[0].startsWith('data:'))
        return null;
    var isURL = false;
    if (((_f = (_e = value === null || value === void 0 ? void 0 : value.properties) === null || _e === void 0 ? void 0 : _e.caption) === null || _f === void 0 ? void 0 : _f.length) > 0) {
        var caption = (_g = value === null || value === void 0 ? void 0 : value.properties) === null || _g === void 0 ? void 0 : _g.caption[0][0];
        var id = parsePageId(caption, { uuid: true });
        var isPage = caption.charAt(0) === '/' && id;
        if ((block.type == 'image' && isValidURL(caption)) || isPage) {
            isURL = true;
        }
    }
    var figure = (React.createElement("div", { className: cs('notion-asset-wrapper', "notion-asset-wrapper-".concat(block.type), ((_h = value.format) === null || _h === void 0 ? void 0 : _h.block_full_width) && 'notion-asset-wrapper-full', blockId) },
        React.createElement(Asset, { block: value }, ((_j = value === null || value === void 0 ? void 0 : value.properties) === null || _j === void 0 ? void 0 : _j.caption) && !isURL && (React.createElement("figcaption", { className: 'notion-asset-caption' },
            React.createElement(Text, { value: value.properties.caption, block: block }))))));
    // allows for an image to be a link
    if (isURL) {
        var caption = (_k = value === null || value === void 0 ? void 0 : value.properties) === null || _k === void 0 ? void 0 : _k.caption[0][0];
        var id = parsePageId(caption, { uuid: true });
        var isPage = caption.charAt(0) === '/' && id;
        var captionHostname = extractHostname(caption);
        return (React.createElement(components.pageLink, { style: { width: '100%' }, href: isPage ? mapPageUrl(id) : caption, target: captionHostname &&
                captionHostname !== rootDomain &&
                !(caption === null || caption === void 0 ? void 0 : caption.startsWith('/'))
                ? 'blank_'
                : null }, figure));
    }
    return React.createElement(ErrorBoundary, null, figure);
};
function isValidURL(str) {
    // TODO: replace this with a more well-tested package
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i');
    return !!pattern.test(str);
}
function extractHostname(url) {
    try {
        var hostname = new URL(url).hostname;
        return hostname;
    }
    catch (err) {
        return '';
    }
}
//# sourceMappingURL=asset-wrapper.js.map